import { without, compose, __, has, update, concat, add, set } from 'lodash/fp';
import { createScopedReducer } from '@mews-commander/utils';
import {
    RESERVATION_ADDED,
    RESERVATION_COUNT_CHANGED,
    RESERVATIONS_CLEARED,
    RESET_SCREEN,
    RESERVATION_CLEARED,
} from '../actions/types';

export const INITIAL_STATE = {
    reservationKeys: [],
};

export default createScopedReducer(INITIAL_STATE, {
    [RESERVATIONS_CLEARED]: () => INITIAL_STATE,

    [RESERVATION_ADDED]: (
        state: $TSFixMe,
        { serviceId, reservation, count, requestedResourceId = null, requestedFloorNumbers = [] }: $TSFixMe
    ) => {
        const { identifier: reservationKey } = reservation;
        if (has(reservationKey, state)) {
            const updatedReservation = state[reservationKey];
            return {
                ...state,
                [reservationKey]: {
                    ...updatedReservation,
                    count: add(count, updatedReservation.count),
                    requestedResourceIds: [
                        ...updatedReservation.requestedResourceIds,
                        ...Array(count).fill(requestedResourceId),
                    ],
                    requestedFloorNumbers: [
                        ...updatedReservation.requestedFloorNumbers,
                        ...Array(count).fill(requestedFloorNumbers),
                    ],
                },
            };
        }
        return compose(
            update('reservationKeys', concat(reservationKey)),
            set(reservationKey, __, state),
            set('requestedFloorNumbers', Array(count).fill(requestedFloorNumbers)),
            set('requestedResourceIds', Array(count).fill(requestedResourceId)),
            set('count', count),
            set('serviceId', serviceId)
        )(reservation);
    },

    [RESERVATION_COUNT_CHANGED]: (state: $TSFixMe, { reservationKey, count }: $TSFixMe) => {
        const { [reservationKey]: reservation, reservationKeys, ...other } = state;
        return {
            ...other,
            reservationKeys,
            [reservationKey]: update('count', add(count), reservation),
        };
    },

    [RESERVATION_CLEARED]: (state: $TSFixMe, { reservationKey }: $TSFixMe) => {
        const { [reservationKey]: reservation, reservationKeys, ...other } = state;
        return {
            ...other,
            reservationKeys: without([reservationKey], reservationKeys),
        };
    },

    [RESET_SCREEN]: () => INITIAL_STATE,
});
